exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.Remove-Dialog-Content {\n  padding-left: 14px;\n  padding-right: 14px;\n}\n.Remove-Dialog-Text {\n  width: 100%;\n  height: 210px;\n}\n", ""]);

